
import get      from 'fn/get.js';
import overload from 'fn/overload.js';

export default overload(get('type'), {
    chord:    (event) => event[4],
    lyric:    (event) => event[2],
    text:     (event) => event[2],
    note:     (event) => event[4],
    sequence: (event) => event[4],
    // Return 0 duration as default
    default:  (event) => 0
});
